/**
 * useDetailEditMode — reads edit mode preference with mobile override.
 *
 * Mobile (< 768px) always forces 'modal' regardless of stored preference.
 * Mirrors useDetailDensity pattern exactly.
 */

import { usePreferencesStore, type DetailEditMode } from "@/lib/store/preferencesStore";
import { useMediaQuery } from "@/hooks/useMediaQuery";

export function useDetailEditMode(): {
  editMode: DetailEditMode;
  setEditMode: (mode: DetailEditMode) => void;
} {
  const stored = usePreferencesStore((s) => s.detailEditMode);
  const setEditMode = usePreferencesStore((s) => s.setDetailEditMode);
  const isDesktop = useMediaQuery("(min-width: 768px)");
  const editMode = isDesktop ? stored : "modal";

  return { editMode, setEditMode };
}
